// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (max-width: 600px) {
.oplus-create-btn[data-v-1b1f27c8] {
      min-width: 30px;
      padding: 2px;
}
}
`, "",{"version":3,"sources":["webpack://./src/vue/components/ImportButton.vue"],"names":[],"mappings":";AAsBE;AACE;MACE,eAAe;MACf,YAAY;AACd;AACF","sourcesContent":["<script setup lang=\"ts\">\nimport ImportIcon from '../icons/ImportIcon.vue';\n\nconst emit = defineEmits<{\n  \"open-import-modal\": []\n}>()\n\n\nfunction handleImportBtnClick() {\n  emit(\"open-import-modal\");\n}\n\n</script>\n\n<template>\n  <button class=\"oplus-btn oplus-create-btn section-btn p-0 font-sm\" @click=\"handleImportBtnClick\">\n    <ImportIcon class=\"rotate-icon\"/>\n    <span class=\"hide-sm\">取込</span>\n  </button>\n</template>\n\n<style scoped>\n  @media (max-width: 600px) {\n    .oplus-create-btn {\n      min-width: 30px;\n      padding: 2px;\n    }\n  }\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
